import { useEffect, useRef } from 'react'
import { Box } from 'vvs-uikit'
import { useLeaderboardQuery } from 'vvs-gotchi-graphql'
import useIntersectionObserver from 'hooks/useIntersectionObserver'
import { moleFromGraphqlData, Rarity } from 'state/vvsgotchi/models'
import { LeaderboardRow } from './LeaderboardRow'
import { ScrollableDiv } from './styles'
import LeaderboardFooter from './LeaderboardFooter'
import { LeaderboardDataLoader } from './LeaderboardDataLoader'
import { LeaderboardTableHeader } from './LeaderboardHeader'

interface ITableProps extends ReturnType<typeof useLeaderboardQuery> {
  rarity: Rarity
}
const LeaderboardTable: React.FC<ITableProps> = ({ data, called, fetchMore, loading, rarity }) => {
  const { observerRef, isIntersecting } = useIntersectionObserver()
  const { observerRef: topObserverRef, isIntersecting: isTopIntersecting } = useIntersectionObserver()

  const moleList = data?.leaderboard?.moles?.edges.map((e) => moleFromGraphqlData(e.node)) ?? []

  useEffect(() => {
    if (
      isIntersecting &&
      called &&
      data?.leaderboard?.moles &&
      data.leaderboard.moles?.edges.length < data.leaderboard.moles.totalCount
    ) {
      fetchMore({
        variables: {
          after: data.leaderboard.moles.pageInfo.endCursor,
        },
      })
    }
  }, [isIntersecting, data?.leaderboard?.moles, called, fetchMore])

  const scrollRef = useRef<HTMLDivElement>(null)
  const scrollToTop = (): void => {
    scrollRef.current.scrollIntoView({
      behavior: 'smooth',
    })
  }

  return (
    <Box>
      <LeaderboardTableHeader />
      <ScrollableDiv>
        <div ref={topObserverRef} />
        <div ref={scrollRef} />
        {moleList.map((m) => (
          <LeaderboardRow key={m.tokenId} mole={m} />
        ))}
        {loading && <LeaderboardDataLoader />}
        <div style={{ transform: 'translateY(-80px)' }} ref={observerRef} />
      </ScrollableDiv>
      <LeaderboardFooter scrollToTop={scrollToTop} isTopIntersecting={isTopIntersecting} rarity={rarity} />
    </Box>
  )
}

export default LeaderboardTable
